<nav
  class="navbar navbar-vertical navbar-expand-md navbar-light bg-white sidebar-shell"
  id="sidenav-main"
>
  <div class="sidebar-brand-bar">
    <a
      class="navbar-brand pt-0"
      routerLinkActive="active"
      [routerLink]="['/company-profile']"
    >
      <img
        src="./assets/img/brand/logo-invertida.png"
        class="navbar-brand-img"
        alt="Tem Cashback"
      />
    </a>
    <button
      class="navbar-toggler d-md-none"
      type="button"
      (click)="isCollapsed = !isCollapsed"
      aria-controls="sidenav-collapse-main"
      aria-label="Abrir menu"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
  <div class="container-fluid sidebar-menu-body">
    <ul class="nav align-items-center d-md-none mb-2">
      <li class="nav-item ml-auto" ngbDropdown placement="bottom-right">
        <a class="nav-link" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img
                alt="Image placeholder"
                [src]="
                  company?.foto
                    ? company?.foto
                    : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg'
                "
              />
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Bem vindo(a)!</h6>
          </div>
          <a
            routerLinkActive="active"
            [routerLink]="['/company-profile']"
            class="dropdown-item"
          >
            <i class="ni ni-single-02"></i>
            <span>Perfil</span>
          </a>
          <a href="#!" class="dropdown-item" (click)="logout()">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
    </ul>
    <!-- Collapse -->
    <div
      class="collapse navbar-collapse"
      [ngbCollapse]="isCollapsed"
      id="sidenav-collapse-main"
    >
      <!-- Collapse header -->
      <div class="navbar-collapse-header d-md-none">
        <div class="row align-items-center">
          <div class="col collapse-close ml-auto">
            <button
              type="button"
              class="navbar-toggler"
              (click)="isCollapsed = !isCollapsed"
            >
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
      <!-- Navigation -->
      <ul class="navbar-nav">
        <li
          *ngFor="let menuItem of menuItems"
          class="{{ menuItem.class }} nav-item"
        >
          <a
            routerLinkActive="active"
            [routerLink]="[menuItem.path]"
            class="nav-link"
          >
            <i class="ni {{ menuItem.icon }}"></i>
            {{ menuItem.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
